import React from 'react';
import { Item, Name, Party } from './styles';

export default ({ name, lastName, party, area, percent, renderInfo, votes }) => (
	<Item>
		<Name>{name} {lastName}</Name>
		<Party title={party.name}>{party.shortcut}</Party>
		{renderInfo({ area, percent, votes })}
	</Item>
)
